import { z } from 'zod';

// Saldo y movimientos (RF-02.01, RF-02.02). Los créditos son enteros (RN-002).

export const balanceSchema = z
  .object({
    available: z.number().int(),
    /** Retenido por operaciones en curso o en revisión. */
    held: z.number().int(),
    /** Bloqueado por membresía (RN-005): se conserva, no se puede usar. */
    frozen: z.number().int(),
  })
  .meta({ id: 'Balance' });

export const movementTypeSchema = z.enum([
  'purchase',
  'promotion',
  'adjustment',
  'reservation',
  'settlement',
  'release',
  'freeze',
  'unfreeze',
  'legacy_import',
  'refund',
]);

export const movementSchema = z.object({
  id: z.uuid(),
  type: movementTypeSchema,
  available: z.number().int(),
  held: z.number().int(),
  frozen: z.number().int(),
  reference: z.string().nullable(),
  reason: z.string(),
  createdAt: z.iso.datetime(),
});

export type Movement = z.infer<typeof movementSchema>;

export const adjustmentRequestSchema = z.object({
  /** Positivo suma y negativo resta créditos del disponible. */
  amount: z.number().int(),
  reason: z.string().max(500),
});

export const adjustmentResponseSchema = z.object({
  transactionId: z.uuid(),
  balance: balanceSchema,
});
